import React, { useState } from 'react';
import ConfigTab from './ui/ConfigTab.jsx';

// Phase 1 shell. One tab (Configuration). Queues, ledger, pipeline, run
// summary, and health report tabs arrive in later phases (§16 module map).
const TABS = [{ id: 'config', label: 'Configuration', Component: ConfigTab }];

export default function App() {
  const [active, setActive] = useState('config');
  const ActiveComponent = TABS.find((t) => t.id === active).Component;

  return (
    <div className="app">
      <header className="app-header">
        <div className="app-title">
          UEE <span className="app-subtitle">Ultimate Ecommerce Engine · Phase 1</span>
        </div>
        <nav className="app-tabs">
          {TABS.map((t) => (
            <button
              key={t.id}
              className={t.id === active ? 'tab tab-active' : 'tab'}
              onClick={() => setActive(t.id)}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </header>
      <main className="app-main">
        <ActiveComponent />
      </main>
    </div>
  );
}
